import { injectedUserOrgApi } from './injectedUserOrgApi';

export const enhancedUserOrgApi = injectedUserOrgApi.enhanceEndpoints({
    addTagTypes: [
        'GetProject',
        'GetApiProjectTag',
        'GetApiRequests',
        'GetApiProjectResource',
        'GetApiProjectByProjectShortNameUsers',
        'GetApiUserInfo',
        'GetApiUserInfoWithHeaders',
        'GetApiProjectResourceAssignment',
        'GetApiUserPreferences',
        'GetApiUserPreferencesParsed',
        'GetApiOtherStatistics',
        'GetApiRequestsSentRequests',
        'CommandTemplates',
        'TemplatesInfo',
        'GetApiOtherCyclopsUsage',
    ],
    endpoints: {
        getApiOtherCyclopsUsageByProjectShortNameAndResourceName: {
            providesTags: ['GetApiOtherCyclopsUsage'],
        },
        getCommandTemplates: {
            providesTags: ['CommandTemplates'],
        },
        templatesInfo: {
            providesTags: ['TemplatesInfo'],
        },
        getApiOtherStatistics: {
            providesTags: ['GetApiOtherStatistics'],
        },
        getProject: {
            providesTags: ['GetProject'],
        },
        getApiProjectTag: {
            providesTags: ['GetApiProjectTag'],
        },
        getApiRequests: {
            providesTags: ['GetApiRequests'],
        },
        getApiRequestsSentRequests: {
            providesTags: ['GetApiRequestsSentRequests'],
        },
        getApiProjectResource: {
            providesTags: ['GetApiProjectResource'],
        },
        getApiUserInfo: {
            providesTags: ['GetApiUserInfo'],
        },
        getApiUserInfoWithHeaders: {
            providesTags: ['GetApiUserInfoWithHeaders'],
        },
        getApiProjectByProjectShortNameUsers: {
            providesTags: ['GetApiProjectByProjectShortNameUsers'],
        },
        getApiProjectResourceAssignment: {
            providesTags: ['GetApiProjectResourceAssignment'],
        },
        getApiUserPreferences: {
            providesTags: ['GetApiUserPreferences'],
        },
        getApiUserPreferencesParsed: {
            providesTags: ['GetApiUserPreferencesParsed'],
        },
        activateCommandTemplate: {
            invalidatesTags: ['CommandTemplates', 'TemplatesInfo'],
        },
        deactivateCommandTemplate: {
            invalidatesTags: ['CommandTemplates', 'TemplatesInfo'],
        },
        createTemplateEndpoint: {
            invalidatesTags: ['CommandTemplates', 'TemplatesInfo'],
        },
        postApiProject: {
            invalidatesTags: ['GetProject', 'GetApiUserInfo', 'GetApiUserInfoWithHeaders', 'GetApiOtherStatistics'],
        },
        putApiProject: {
            invalidatesTags: ['GetProject', 'GetApiOtherStatistics'],
        },
        deleteApiProjectByProjectShortName: {
            invalidatesTags: ['GetProject', 'GetApiOtherStatistics'],
        },
        putApiProjectByProjectShortNameProjectResourceAndProjectResourceName: {
            invalidatesTags: ['GetProject', 'GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        deleteApiProjectByProjectShortNameProjectResourceAndProjectResourceName: {
            invalidatesTags: ['GetProject', 'GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        deleteApiProjectTagById: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag', 'GetApiOtherStatistics'],
        },
        putApiProjectByProjectShortNameProjectTagAndProjectTagId: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag'],
        },
        postApiProjectTag: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag'],
        },
        putApiProjectTag: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag'],
        },
        putApiRequestsByRequestIdReject: {
            invalidatesTags: ['GetProject', 'GetApiProjectByProjectShortNameUsers', 'GetApiRequests'],
        },
        putApiRequestsByRequestIdAccept: {
            invalidatesTags: ['GetProject', 'GetApiProjectByProjectShortNameUsers', 'GetApiRequests'],
        },
        postApiProjectResource: {
            invalidatesTags: ['GetProject', 'GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        deleteApiProjectByProjectShortNameUserAndIdpUserId: {
            invalidatesTags: ['GetProject', 'GetApiProjectByProjectShortNameUsers', 'GetApiOtherStatistics'],
        },
        putApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleId: {
            invalidatesTags: ['GetApiProjectByProjectShortNameUsers'],
        },
        deleteApiProjectByProjectShortNameProjectTagAndProjectTagId: {
            invalidatesTags: ['GetProject', 'GetApiProjectTag'],
        },
        postApiRequests: {
            invalidatesTags: ['GetApiProjectTag', 'GetApiRequestsSentRequests'],
        },
        postApiProjectResourceAssignment: {
            invalidatesTags: ['GetApiProjectResourceAssignment'],
        },
        putApiProjectResourceAssignment: {
            invalidatesTags: ['GetApiProjectResourceAssignment'],
        },
        deleteApiProjectResourceAssignmentById: {
            invalidatesTags: ['GetApiProjectResourceAssignment'],
        },
        putApiProjectResource: {
            invalidatesTags: ['GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        deleteApiProjectResourceById: {
            invalidatesTags: ['GetApiProjectResource', 'GetApiOtherStatistics'],
        },
        putApiUserPreferences: {
            invalidatesTags: ['GetApiUserPreferences', 'GetApiUserPreferencesParsed'],
        },
    },
});

export const {
    useGetVersionQuery,
    useGetCommandTemplatePermissionsQuery,
    useGetCommandTemplatesQuery,
    useActivateCommandTemplateMutation,
    useDeactivateCommandTemplateMutation,
    useWorkerDataQuery,
    useGetApiHeappeListChangedFilesForJobByProjectShortNameAndResourceNameSubmittedJobInfoIdQuery,
    useGetApiOtherCountryQuery,
    useGetApiOtherStatisticsQuery,
    useGetApiProjectByProjectShortNameUsersQuery,
    useGetProjectQuery,
    usePostApiProjectMutation,
    usePutApiProjectMutation,
    usePutApiProjectByProjectShortNameUserAndIdpUserIdAssignRoleIdMutation,
    useDeleteApiProjectByProjectShortNameMutation,
    usePutApiProjectByProjectShortNameProjectResourceAndProjectResourceNameMutation,
    useDeleteApiProjectByProjectShortNameProjectResourceAndProjectResourceNameMutation,
    usePutApiProjectByProjectShortNameUserAndIdpUserIdMutation,
    useDeleteApiProjectByProjectShortNameUserAndIdpUserIdMutation,
    usePutApiProjectByProjectShortNameProjectTagAndProjectTagIdMutation,
    useDeleteApiProjectByProjectShortNameProjectTagAndProjectTagIdMutation,
    useTemplatesInfoQuery,
    useExtendedProjectInfoQuery,
    useValidRolesQuery,
    useGetApiProjectResourceAssignmentQuery,
    usePostApiProjectResourceAssignmentMutation,
    usePutApiProjectResourceAssignmentMutation,
    useGetProjectResourceAssignmentQuery,
    useDeleteApiProjectResourceAssignmentByIdMutation,
    useGetApiProjectResourceQuery,
    useLazyGetApiProjectResourceQuery,
    usePostApiProjectResourceMutation,
    usePutApiProjectResourceMutation,
    useGetProjectResourceQuery,
    useDeleteApiProjectResourceByIdMutation,
    useGetApiProjectTagQuery,
    usePostApiProjectTagMutation,
    usePutApiProjectTagMutation,
    useGetProjectTagQuery,
    useDeleteApiProjectTagByIdMutation,
    usePostApiPublicHandleByActionLinkMutation,
    useGetApiPublicRequestInfoByRequestIdQuery,
    useGetApiRequestsQuery,
    usePostApiRequestsMutation,
    useGetApiRequestsSentRequestsQuery,
    usePutApiRequestsByRequestIdAcceptMutation,
    usePutApiRequestsByRequestIdRejectMutation,
    useSyncDetailsQuery,
    useProjectsInfoQuery,
    useGetApiUserPreferencesQuery,
    usePutApiUserPreferencesMutation,
    useGetApiUserInfoQuery,
    useGetApiUserInfoExtendedQuery,
    useGetApiUserPreferencesParsedQuery,
    useGetApiOtherCyclopsUsageByProjectShortNameAndResourceNameQuery,
    useLazyGetApiOtherCyclopsUsageByProjectShortNameAndResourceNameQuery,
    useGetApiUserInfoWithHeadersQuery,
    useLazyGetCommandTemplatesQuery,
    useGetPartitionsEndpointQuery,
    useLazyGetPartitionsEndpointQuery,
    useCreateTemplateEndpointMutation,
} = enhancedUserOrgApi;
